import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dimmer, Dropdown, Icon, Loader, Popup } from 'semantic-ui-react'
import { ProfileQuery } from '~/QueryHooks/ProfileQuery'
import { StyledDropdownMenu, StyledLabel } from './style'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';
import { Link } from 'react-router-dom'
import { ThemeContext } from 'styled-components'
import { RouteTypes } from '~/routes/constants'

const Notifications: React.FC = () => {
  const { t } = useTranslation()
  const [dropdownOpened, setDropdownOpened] = useState(false)
  const { firstColor } = useContext(ThemeContext)
  dayjs.extend(relativeTime)

  const {
    data: notificationCount,
    isLoading: isLoadingCount
  } = ProfileQuery.getNotificationCount()

  const {
    data: notifications,
    isLoading: isLoadingNotifications,
    refetch: refetchNotifications,
    isFetching: isFetchingNotifications
  } = ProfileQuery.getNewNotifications(dropdownOpened)

  useEffect(() => {
    if (dropdownOpened) {
      refetchNotifications()
    }
  }, [dropdownOpened])

  function getParsedUrl(url) {
    return url === '' ? '' : url.split('/')?.filter((_, index) => index > 2).join('/')
  }

  const loading = isFetchingNotifications || isLoadingNotifications

  return <Dropdown
    scrolling
    onClose={() => setDropdownOpened(false)}
    onOpen={() => setDropdownOpened(true)}
    icon={<Popup
      content={t('Notifications')}
      trigger={<div>
        <Icon style={{ color: 'white', cursor: 'pointer' }} name='bell' size='large' />
        {Boolean(notificationCount) && <StyledLabel color={'red'} floating>
          {notificationCount > 99 ? '99+' : notificationCount || 0}
        </StyledLabel>
        }
      </div>}
    />}
  >
    <StyledDropdownMenu>
      <Dimmer inverted active={loading}>
        <Loader active={loading} />
      </Dimmer>
      <Dropdown.Header>
        <div>{t('Notifications')}</div>
        <Button
          as={Link}
          to={RouteTypes.NOTIFICATIONS}
          style={{ marginLeft: 30, color: 'white', background: firstColor }}
        >
          {t('Show all')}
        </Button>
      </Dropdown.Header>
      <Dropdown.Divider />
      {notifications?.map((notification, index) => {
        const url = getParsedUrl(notification?.url?.toString())
        return <>
          {index > 0 && <Dropdown.Divider />}
          <Dropdown.Item
            as={url ? Link : 'div'}
            to={url}
            onClick={(e) => {
              if (!url) {
                e.preventDefault()
                e.stopPropagation()
              }
            }}
            key={notification?.createdAt}
            className={url ? 'hasUrl' : ''}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: url ? 'pointer' : 'default'
            }}
          >
            <div>
              <div className='titleItem'>
                {notification?.readAt && <Popup
                  content={t('Read at: {{time}}', { time: dayjs(notification?.readAt).format('DD.MM.YYYY HH:mm') })}
                  trigger={<Icon style={{ color: firstColor }} name='clock' size='large' />}
                />}
                <div style={{ marginLeft: !notification?.readAt && 30 }} className='date'>{dayjs(notification?.createdAt).fromNow()}</div>
              </div>
              <div className='descriptionItem'>
                <div>{notification?.description}</div>
              </div>
            </div>
            <Icon
              name={notification?.readAt ? 'checkmark' : 'close'}
              color={notification?.readAt ? 'green' : 'red'}
            />
          </Dropdown.Item>
        </>
      })}
    </StyledDropdownMenu>
  </Dropdown>
}
export default Notifications